// @flow
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { scrollX } from '@finect/tabular-utils/scrollX';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.uiLL};
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-top: 40px;
  padding-bottom: 20px;
  margin-bottom: 40px;
  width: 100%;
`;

export const TopAnswers = styled.div`
  position: relative;
  display: flex;
  max-width: ${({ theme }) => theme.maxWidth};

  ${scrollX}

  ${maxMediaQueries.hugeScreen`
    max-width: 95vw;
  `}
`;
